export default ({
    name : 'IntroduceContent'
    , data () {
        return {
            pageKinTypeText : 'PAGEKIN'
            , pageKinJsSrcDev : '/assets/shop/js/pagekin.js'
            , pageKinJsSrcReal : '//image.makeshop.co.kr/pagekin/widget/mysoho.js'
            , htmlTypeText : 'TEXT'
            , pageKinFindStr : 'PKMW'
        }
    }
    , created () {
        this.code = 'introduce_content';
        this.basic = this.getDetailDataByCode(this.code);
        return {}
    }
    , mounted () {
        if (templateType == 'blog') {
            if (this.isUsePageKin()) {
                this.pageKinJsLoad()
            }
            let visualTopEle = document.querySelector('#tpl-blog .base .visualTop')
            if (typeof visualTopEle != 'undefined' && visualTopEle != null) {
                visualTopEle.style.paddingTop = `${document.querySelector('#tpl-blog #header').offsetHeight}px`
            }
        }
    }
    , computed : {
        isUseHtml () {
            if (this.basic.use == 'N') return false;
            if (this.basic.data.type.value != this.htmlTypeText) return false;
            return true;
        }
        , content () {
            return this.basic.data.content.value
        }
        , isNoContent () {
            return (this.basic.data.content.value.length == 0)
        }
        , contentDefault () {
            return this.basic.data.content.default
        }
    }
    , methods : {
        isUsePageKin () {
            if (this.basic.use == 'N') return false;
            if (this.basic.data.type.value != this.pageKinTypeText) return false;
            if (this.basic.data.content.value.indexOf(this.pageKinFindStr) < 1) {
                this.basic.data.type.value = this.htmlTypeText
                return false;
            }
            return true;
        }
        , pageKinJsLoad () {
            var pagekinCallback = function () {
                if (typeof pkwg == 'function') {
                    pkwg()
                }
            }
            if (this.isPageKinJsLoaded()) { 
                pagekinCallback()
                return 
            }
            let _src = `${this.baseURI}${this.pageKinJsSrcDev}`
            if (this.isRealServer()) {
                _src = this.pageKinJsSrcReal
            }
            const plugin = document.createElement("script")
            plugin.type = 'text/javascript'
            plugin.setAttribute(
                "src"
                , _src
            )
            plugin.setAttribute("id", "js-pagekin-src")
            plugin.async = true
            plugin.onload = pagekinCallback 
            let x = document.getElementsByTagName('script')[0]
            x.parentNode.insertBefore(plugin, x) 
        }
        , isPageKinJsLoaded () {
            let pagekin = document.getElementById('js-pagekin-src');
            if (typeof pagekin == 'undefined' || pagekin === null) return false
            return true
        }
    }
    , updated () {
        if (templateType == 'blog') {
            let visualTopEle = document.querySelector('#tpl-blog .base .visualTop')
            if (typeof visualTopEle != 'undefined' && visualTopEle != null) {
                visualTopEle.style.paddingTop = `${document.querySelector('#tpl-blog #header').offsetHeight}px`
            }
        }
        if (this.isUsePageKin()) {
            this.pageKinJsLoad()
        }
    }
})
